import { createFileRoute } from '@tanstack/react-router';
import { MfaPage } from '@/features/auth/mfa-page';

export const Route = createFileRoute('/auth/mfa')({
    validateSearch: (search: Record<string, unknown>): { next?: string } =>
        typeof search.next === 'string' ? { next: search.next } : {},
    component: function MfaRoute() {
        const { next } = Route.useSearch();
        return <MfaPage next={next} />;
    },
});
